import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_467z7rvjdf: FaireBrandEntity = {
  token: "b_467z7rvjdf",
  type: "brand",
  name: "Erika's Whimsical Art",
  avatarUrl:
    "https://cdn.faire.com/fastly/55d32cf750411d0b1c6b07155ae0834a975ed562a2e2038630fc36b8902c29ab.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/760feac259578957c97a8da9f60ea0279ed3570167d4ac208d5b4cdcae5443b7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/55d32cf750411d0b1c6b07155ae0834a975ed562a2e2038630fc36b8902c29ab.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/760feac259578957c97a8da9f60ea0279ed3570167d4ac208d5b4cdcae5443b7.png",
  location: "GBR",
  minimumOrderDollars: 68,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: false,
  description:
    "Founded in 2016, Erika’s Whimsical Art is a small creative studio based in the UK, creating beautifully illustrated, eco-conscious stationery inspired by nature, quiet moments, and the changing seasons.\n\nEvery design begins as an original illustration by Erika before becoming part of a thoughtfully handcrafted collection. From the first sketch to the final spiral binding, each piece is created with great care and attention to detail.\n\nOur collection includes illustrated notebooks, wall and perpetual calendars, premium cotton greeting cards, art prints, and our signature plantable seed paper greeting cards, available exclusively within the UK due to international seed shipping regulations.\n\nWhether printed on premium cotton paper or plantable seed paper, every product is designed to bring joy, beauty, and a little everyday magic into people’s lives.\n\nLet’s grow something beautiful together.\n\nContent Usage Note (For Retailers)\n\nRetailers are welcome to use product photos from my Faire listings and website to promote the products in their own shops. Credit to Erika’s Whimsical Art is always appreciated.\n\nVideos, Reels, behind-the-scenes content, studio footage, and process videos remain the exclusive property of Erika’s Whimsical Art and may not be copied or redistributed.\n\nThank you for supporting independent artists and respecting the creativity behind every piece.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.276Z",
    importedBy: "entity-db-cli",
  },
};
